define([], () => {
    'use strict';

    const defaults = {
        type: 'click',
        cb: null,
        selector: 'body'
    };

    /**
     * @param {Object} config configuration obj
     * @param {Element|null} el subject
     */
    function initialize (config, el) {
        config = Object.assign(defaults, config);
        if (!el || !(config.cb in el)) {
            return;
        }
        const target = el.ownerDocument.querySelector(config.selector);
        if (!target) {
            return;
        }
        target.addEventListener(config.type, e => el[config.cb]());
    }

    return initialize;
});
